import { memo, useContext, useMemo } from 'react';
import UserContext from '@/contexts/user';

import * as styles from '@/styles/components/Avatar';

type Avatar = {
  size?: 'sm' | 'md' | 'lg';
};

const Avatar = ({ size = 'md' }: Avatar) => {
  const user = useContext(UserContext);
  const initialLetter = useMemo(() => {
    return user?.email?.charAt(0).toUpperCase();
  }, [user?.email]);

  // width/height と font-size
  const style = useMemo(() => {
    switch (size) {
      case 'sm':
        return ['3.2rem', '1.4rem'];
      case 'md':
        return ['4.8rem', '1.6rem'];
      case 'lg':
        return ['6.4rem', '2.1rem'];
      default:
        return ['4.8rem', '1.6rem'];
    }
  }, [size]);

  return (
    <span css={styles.root(style)} data-testid='avatar'>
      {initialLetter}
    </span>
  );
};

export default memo(Avatar);
